
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import ChangePasswordForm from "@/components/ChangePasswordForm.vue";

@Options({
  components: {
    Header,
    ChangePasswordForm
  }
})
export default class ChangePassword extends Vue {}
